import axiosInstance from "auth/FetchInterceptor";
import { FAVORITE_MENU_API } from "constants/ApiConstant";

const FavoriteMenuService = {};

FavoriteMenuService.getFavoriteMenus = function () {
  return axiosInstance.get(FAVORITE_MENU_API, {
    baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
  });
};

FavoriteMenuService.updateFavoriteMenus = function (menus) {
  return axiosInstance.put(FAVORITE_MENU_API, menus, {
    baseURL: process.env.REACT_APP_IDENTITY_ENDPOINT_URL,
  });
};

export default FavoriteMenuService;
